export default function Carteira() {
    return (
        <>
        <h1>Teste</h1></>
    )
}